var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50016 0.333496C7.86835 0.333496 8.16683 0.631973 8.16683 1.00016V6.3335H13.5002C13.8684 6.3335 14.1668 6.63197 14.1668 7.00016C14.1668 7.36835 13.8684 7.66683 13.5002 7.66683H8.16683V13.0002C8.16683 13.3684 7.86835 13.6668 7.50016 13.6668C7.13197 13.6668 6.8335 13.3684 6.8335 13.0002V7.66683H1.50016C1.13197 7.66683 0.833496 7.36835 0.833496 7.00016C0.833496 6.63197 1.13197 6.3335 1.50016 6.3335H6.8335V1.00016C6.8335 0.631973 7.13197 0.333496 7.50016 0.333496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGlobal);
export default __webpack_public_path__ + "static/media/plusGlobal.960cc36fd9b9d9078df99de3936de615.svg";
export { ForwardRef as ReactComponent };